import React, { useState } from 'react';
import propTypes from 'prop-types';
import UserCircleBold from 'stash/assets/png/user-circle-bold.svg';
import { Flex, Box, Logo, Image, Link } from '@stashinvest/ui';
import { isMobileWeb } from 'stash/utils/mobile';
import MobileSettingsDrawer from 'stash/components/global/MobileSettingsDrawer/MobileSettingsDrawer';

export const SettingsNavbar = ({
	drawerOpen,
	logOut,
	user,
	avatar,
	showMarketReport,
}) => {
	const [isModalOpen, setModalOpen] = useState(false);
	const redirectToSettings = () => {
		if (window.location.hostname === 'app-local.stash.com') {
			window.location.href = 'https://app-local.stash.com:57454/account-settings';
		} else {
			window.location.href = '/account-settings';
		}
	};
	const onProfileIconClick = () => {
		if (isMobileWeb()) {
			setModalOpen(true);
		} else {
			redirectToSettings();
		}
	};

	return (
		<span data-testid="global-settings-header-legacy">
			<Box width="100%" py="s" px="xs" bg="bgPrimary">
				<Flex
					justifyContent="space-between"
					alignItems="center"
					maxWidth="1280px"
					mx="auto"
				>
					<Box>
						<Link href="/sign-up/state-zero">
							<Logo zIndex="1" height="1.3rem" />
						</Link>
					</Box>
					<Image
						style={{ cursor: 'pointer' }}
						size="36px"
						src={UserCircleBold}
						onClick={onProfileIconClick}
						alt="Account settings"
						aria-label="Account settings"
					/>
				</Flex>
			</Box>
			{isModalOpen && (
				<MobileSettingsDrawer
					active={drawerOpen}
					close={() => {
						setModalOpen(false);
					}}
					logOut={logOut}
					isStateZero={true}
					hasAdvisorySignature={true}
					user={user}
					avatar={avatar}
					showMarketReport={showMarketReport}
				/>
			)}
		</span>
	);
};

SettingsNavbar.propTypes = {
	close: propTypes.func,
	drawerOpen: propTypes.bool,
	logOut: propTypes.func,
	user: propTypes.object,
	avatar: propTypes.string,
	showMarketReport: propTypes.bool,
};

export default SettingsNavbar;
